// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__gJGcb","productName":"Table_productName__2FiVZ"};